// Configuración de la simulación
export const HABILIDADES_DISPONIBLES = {
    "LIDERAZGO": {
        "nombre": "LIDERAZGO",
        "descripcion": "El liderazgo emocionalmente inteligente se basa en la capacidad de inspirar, guiar e influir positivamente en los demás, alineando sus motivaciones con una visión común. Requiere autoconciencia (para conocer los propios valores y convicciones), autorregulación (para actuar con calma y coherencia), y una fuerte motivación interna. Un líder no impone, sino que moviliza a través del propósito y el ejemplo. - Aplicado al SARAS: El especialista es capaz de explicar con claridad el propósito de la evaluación ambiental y social, reflejando los valores del IF. Motiva al cliente a comprometerse con la mejora continua, actuando como un referente en sostenibilidad. - Ejemplos esperados: Comunica con seguridad y convicción el propósito del SARAS, Relaciona la evaluación con beneficios sociales y ambientales de forma comprensible. Motiva al cliente a participar activamente en la mejora continua. Toma la iniciativa en la conversación, pero sin dominarla."
    },
    "COMUNICACIÓN Y ESCUCHA ACTIVA": {
        "nombre": "COMUNICACIÓN Y ESCUCHA ACTIVA",
        "descripcion": "Definición: Una persona emocionalmente inteligente domina la escucha activa y la comunicación empática, usando habilidades sociales y empatía para generar confianza, construir relaciones sólidas y lograr entendimiento mutuo. Implica estar realmente presente, observar el lenguaje no verbal, hacer preguntas significativas, y validar lo que el otro expresa. - Aplicado al SARAS: El especialista hace preguntas abiertas, escucha sin interrumpir, y reformula lo que escucha para asegurar comprensión. Transmite ideas técnicas de manera clara y muestra respeto en su comunicación, incluso ante situaciones tensas o sensibles. - Ejemplos esperados: Formula preguntas tipo ¿cómo?, ¿por qué?, ¿qué opinas? Escucha sin interrumpir, mantiene contacto visual. Reformula o resume para validar entendimiento. Usa un lenguaje claro, sin imponer."
    },
    "PLANIFICACIÓN Y GESTIÓN DEL TIEMPO": {
        "nombre": "PLANIFICACIÓN Y GESTIÓN DEL TIEMPO",
        "descripcion": "Definición: Esta habilidad está conectada con la autorregulación (manejar bien las emociones frente a la presión o lo inesperado) y con la motivación (mantener el enfoque y los objetivos claros). Una persona emocionalmente inteligente sabe priorizar, planificar, adaptarse a los imprevistos sin perder el control ni la eficacia. - Aplicado al SARAS: El especialista organiza la visita con anticipación, comunica la agenda, ajusta actividades si es necesario sin perder de vista lo esencial, y demuestra eficiencia en el uso del tiempo, tanto propio como del cliente. - Ejemplos esperados: Presenta una agenda clara desde el inicio. Se adapta a imprevistos manteniendo el objetivo. Prioriza puntos críticos de evaluación si hay retrasos. Cierra la visita dejando tiempo para retroalimentación."
    },
    "FLEXIBILIDAD": {
        "nombre": "FLEXIBILIDAD",
        "descripcion": "Definición: La flexibilidad es una combinación de autorregulación emocional (adaptarse sin reaccionar de forma negativa) y empatía (entender que cada persona y organización tiene su propio ritmo y estilo). Implica dejar ir la rigidez, mantener la apertura ante nuevas ideas o condiciones, y manejar los cambios con ecuanimidad. - Aplicado al SARAS: El especialista adapta su enfoque a la realidad del cliente, responde con comprensión ante imprevistos o actitudes evasivas, y busca avanzar sin confrontaciones, sin renunciar a la revisión de los estándares clave. - Ejemplos esperados: Reorganiza la agenda sin frustración. Acepta cambios en el orden o personal disponible sin incomodidad. Mantiene el propósito de la visita a pesar de interrupciones. Muestra respeto ante culturas organizacionales distintas."
    },
    "NEGOCIACIÓN": {
        "nombre": "NEGOCIACIÓN",
        "descripcion": "Definición: Goleman define la negociación como una expresión de habilidades sociales, empatía e influencia. Es la capacidad de encontrar puntos de acuerdo con otras personas o partes interesadas, defendiendo posiciones sin confrontar, y buscando soluciones donde ambas partes se sientan respetadas. La clave es construir consensos desde la comprensión mutua, no desde el poder o la imposición. - Aplicado al SARAS: El especialista escucha la position del cliente, propone soluciones técnicas con lógica, y está abierto a negociar alternativas viables que respeten los estándares. No impone, pero mantiene el cumplimiento como un objetivo no negociable. - Ejemplos esperados: Escucha primero las propuestas del cliente. Propone mejoras justificando técnicamente. Acepta alternativas si cumplen con el estándar. Mantiene firmeza con cortesía."
    }
};

// Mapeo de clave de habilidad (frontend) a slug para el backend
export const SKILL_SLUGS = {
    'LIDERAZGO': 'liderazgo',
    'COMUNICACIÓN Y ESCUCHA ACTIVA': 'comunicacion',
    'PLANIFICACIÓN Y GESTIÓN DEL TIEMPO': 'planificacion',
    'FLEXIBILIDAD': 'flexibilidad',
    'NEGOCIACIÓN': 'negociacion'
};

// Mapeo inverso: slug del backend → clave del frontend
export const SKILL_SLUGS_REVERSE = {
    'liderazgo': 'LIDERAZGO',
    'comunicacion': 'COMUNICACIÓN Y ESCUCHA ACTIVA',
    'planificacion': 'PLANIFICACIÓN Y GESTIÓN DEL TIEMPO',
    'flexibilidad': 'FLEXIBILIDAD',
    'negociacion': 'NEGOCIACIÓN'
};

// Plantilla de skill_config por slug (para primera llamada /simulation)
export const SKILL_CONFIG_TEMPLATES = {
    negociacion: {
        criteria: {
            escucha_posicion_cliente: {
                nivel_minimo: 1,
                indicadores: [
                    'deja al representante terminar antes de responder',
                    'identifica un interés clave del representante',
                    'considera el punto de vista del otro antes de argumentar'
                ]
            },
            alternativa_con_condiciones: {
                nivel_minimo: 2,
                indicadores: [
                    'propone una alternativa concreta',
                    "declara condiciones explícitas ('si X, entonces Y')",
                    'señala qué cede cada parte'
                ]
            },
            firmeza_estandar: {
                nivel_minimo: 2,
                indicadores: [
                    'mantiene el estándar como no negociable',
                    'rechaza propuestas que incumplan la norma sin confrontar',
                    'justifica técnicamente por qué no es suficiente'
                ]
            },
            reciprocidad: {
                nivel_minimo: 3,
                indicadores: [
                    'identifica qué está dispuesto a ceder el otro',
                    'propone un acuerdo de ganancia mutua',
                    'cierra con compromiso verificable y plazo'
                ]
            }
        },
        challenge_templates: [
            {
                id: 'escuchar_posicion',
                label: 'Escuchar la posición del representante',
                nivel: 1,
                template: 'El representante expresa su desacuerdo con un requerimiento. El especialista debe escuchar sin interrumpir, identificar la preocupación principal y mostrar que la ha comprendido antes de responder.'
            },
            {
                id: 'identificar_intereses',
                label: 'Identificar intereses del representante',
                nivel: 1,
                template: 'El representante explica por qué le resulta difícil cumplir la medida correctiva. El especialista debe identificar cuáles son sus intereses reales y reconocerlos antes de proponer soluciones.'
            },
            {
                id: 'propuesta_inicial',
                label: 'Propuesta inicial sencilla',
                nivel: 1,
                template: 'El representante acepta que hay un problema pero no sabe cómo resolverlo. El especialista debe proponer una solución concreta y sencilla como punto de partida para la negociación.'
            },
            {
                id: 'alternativa_condiciones',
                label: 'Alternativa con condiciones',
                nivel: 2,
                template: 'El representante rechaza la medida correctiva. Pide al especialista que proponga una alternativa concreta con condiciones explícitas: qué se requiere, qué plazo y qué ocurre si no se cumple.'
            },
            {
                id: 'reciprocidad_negociacion',
                label: 'Reciprocidad en la negociación',
                nivel: 2,
                template: 'El representante pregunta qué gana él si acepta el requerimiento. El especialista debe identificar un beneficio mutuo y proponer un acuerdo donde ambas partes cedan algo concreto.'
            },
            {
                id: 'busqueda_acuerdo_parcial',
                label: 'Acuerdo parcial por etapas',
                nivel: 2,
                template: 'El representante se niega a aceptar todas las medidas correctivas a la vez. El especialista debe identificar cuáles puede aceptar primero y proponer un plan por etapas con plazos definidos.'
            },
            {
                id: 'firmeza_ante_resistencia',
                label: 'Firmeza ante resistencia',
                nivel: 3,
                template: 'El representante insiste en que la norma no aplica a su proyecto. El especialista debe mantener su posición con argumentos técnicos sin confrontar, dejando claro que el estándar es innegociable.'
            },
            {
                id: 'desbloquear_negociacion',
                label: 'Desbloquear una negociación estancada',
                nivel: 3,
                template: 'La negociación se ha estancado porque el representante no acepta ninguna de las propuestas. El especialista debe cambiar de enfoque, encontrar un ángulo nuevo y reabrir el diálogo sin confrontar.'
            },
            {
                id: 'negociar_multiples_partes',
                label: 'Negociación con múltiples actores',
                nivel: 3,
                template: 'El representante menciona que otros actores internos se oponen al cambio. El especialista debe proponer una estrategia que considere a múltiples partes y facilite un acuerdo integral.'
            }
        ]
    },
    comunicacion: {
        criteria: {
            escucha_activa: {
                nivel_minimo: 1,
                indicadores: [
                    'parafrasea antes de responder',
                    'pregunta retomando un punto del interlocutor',
                    'no interrumpe y valida antes de responder'
                ]
            },
            estructura_mensaje: {
                nivel_minimo: 2,
                indicadores: [
                    'enuncia el hallazgo o punto central con claridad',
                    'respalda con un ejemplo o dato concreto',
                    'cierra con un siguiente paso claro'
                ]
            },
            lenguaje_tecnico_accesible: {
                nivel_minimo: 2,
                indicadores: [
                    'explica lo técnico sin perder precisión',
                    'adapta el lenguaje al interlocutor',
                    'usa preguntas abiertas para generar diálogo'
                ]
            },
            comunicacion_empatica_bajo_tension: {
                nivel_minimo: 3,
                indicadores: [
                    'valida la emoción antes del contenido',
                    'mantiene la calma ante reacciones hostiles',
                    'reformula si el otro se cierra emocionalmente'
                ]
            }
        },
        challenge_templates: [
            {
                id: 'reformulacion_activa',
                label: 'Reformulación activa',
                nivel: 1,
                template: 'El representante da una respuesta vaga o contradictoria. El especialista debe parafrasear lo escuchado y hacer una pregunta de seguimiento para aclarar.'
            },
            {
                id: 'pregunta_abierta',
                label: 'Uso de pregunta abierta',
                nivel: 1,
                template: 'El representante se muestra hermético. El especialista debe formular al menos una pregunta abierta que invite a explicar más sobre la situación.'
            },
            {
                id: 'validar_comprension',
                label: 'Validar comprensión mutua',
                nivel: 1,
                template: 'El representante da una explicación técnica extensa. El especialista debe resumir en sus propias palabras lo que entendió y confirmar con el representante si la comprensión es correcta.'
            },
            {
                id: 'mensaje_estructurado',
                label: 'Comunicar hallazgo con estructura',
                nivel: 2,
                template: 'El representante minimiza un hallazgo crítico. El especialista debe comunicarlo con estructura clara: qué se observó, por qué es un problema y cuál es el siguiente paso esperado.'
            },
            {
                id: 'adaptar_lenguaje',
                label: 'Adaptar lenguaje técnico',
                nivel: 2,
                template: 'El representante no entiende los términos técnicos utilizados. El especialista debe reformular su mensaje usando lenguaje accesible sin perder la precisión del hallazgo.'
            },
            {
                id: 'comunicar_con_datos',
                label: 'Respaldar con datos concretos',
                nivel: 2,
                template: 'El representante cuestiona la gravedad del hallazgo. El especialista debe respaldar su comunicación con datos, cifras o referencias normativas concretas para dar peso a su mensaje.'
            },
            {
                id: 'comunicar_hallazgo_sensible',
                label: 'Comunicar hallazgo crítico con empatía',
                nivel: 3,
                template: 'El representante se pone a la defensiva ante un hallazgo grave. El especialista debe comunicar el problema con empatía pero sin suavizar la gravedad, manteniendo la relación profesional.'
            },
            {
                id: 'gestionar_interrupcion',
                label: 'Retomar mensaje tras interrupciones',
                nivel: 3,
                template: 'El representante interrumpe constantemente al especialista. El especialista debe retomar la palabra de forma asertiva y completar su mensaje con estructura y claridad.'
            },
            {
                id: 'reformular_ante_emocion',
                label: 'Reformular ante reacción emocional',
                nivel: 3,
                template: 'El representante reacciona emocionalmente ante un hallazgo. El especialista debe validar la emoción, reformular su mensaje con calma y reconducir la conversación hacia soluciones.'
            }
        ]
    },
    liderazgo: {
        criteria: {
            presentacion_rol_y_objetivo: {
                nivel_minimo: 1,
                indicadores: [
                    'se presenta con nombre, rol y organización',
                    'explica el objetivo de la visita con claridad',
                    'establece un tono colaborativo desde el inicio'
                ]
            },
            comunicacion_proposito: {
                nivel_minimo: 2,
                indicadores: [
                    'explica el propósito de la evaluación A&S',
                    'conecta la evaluación con beneficios para el proyecto',
                    'guía con argumentos, no con autoridad'
                ]
            },
            motivacion_mejora_continua: {
                nivel_minimo: 2,
                indicadores: [
                    'motiva a comprometerse con mejoras concretas',
                    'presenta la mejora como oportunidad, no sanción',
                    'genera apertura a colaborar voluntariamente'
                ]
            },
            iniciativa_en_conversacion: {
                nivel_minimo: 3,
                indicadores: [
                    'guía la conversación hacia los temas críticos',
                    'anticipa objeciones y las aborda',
                    'cierra cada punto con un compromiso claro'
                ]
            }
        },
        challenge_templates: [
            {
                id: 'presentacion_profesional',
                label: 'Presentación profesional',
                nivel: 1,
                template: 'El representante pregunta quién es el especialista y a qué viene. El especialista debe presentarse con profesionalismo, explicar su rol y el objetivo de la visita de forma clara y accesible.'
            },
            {
                id: 'establecer_confianza',
                label: 'Establecer clima de confianza',
                nivel: 1,
                template: 'El representante se muestra desconfiado al inicio de la visita. El especialista debe generar un clima de confianza explicando que su rol es de acompañamiento, no de auditoría punitiva.'
            },
            {
                id: 'contextualizar_evaluacion',
                label: 'Contextualizar la evaluación',
                nivel: 1,
                template: 'El representante no comprende por qué recibe esta visita. El especialista debe contextualizar la evaluación dentro del proceso de financiamiento y explicar los beneficios para el proyecto.'
            },
            {
                id: 'comunicar_proposito_saras',
                label: 'Comunicar el propósito del SARAS',
                nivel: 2,
                template: 'El representante pregunta por qué debe cumplir con estándares del IF si ya cumple la normativa local. El especialista debe explicar con convicción el propósito y valor del proceso de evaluación.'
            },
            {
                id: 'motivar_compromiso',
                label: 'Motivar compromiso voluntario',
                nivel: 2,
                template: 'El representante solo quiere cumplir el mínimo para obtener el crédito. El especialista debe motivarle a ver el valor de las mejoras ambientales más allá del requisito.'
            },
            {
                id: 'alinear_con_vision',
                label: 'Alinear hallazgos con visión de sostenibilidad',
                nivel: 2,
                template: 'El representante ve la evaluación como un trámite burocrático. El especialista debe conectar los hallazgos con la visión de sostenibilidad del proyecto y mostrar cómo la mejora genera valor más allá del cumplimiento.'
            },
            {
                id: 'iniciativa_temas_criticos',
                label: 'Tomar la iniciativa en temas críticos',
                nivel: 3,
                template: 'El representante intenta desviar la conversación hacia temas secundarios. El especialista debe recuperar el foco en el hallazgo crítico de forma natural y sin confrontación.'
            },
            {
                id: 'liderazgo_bajo_presion',
                label: 'Liderar bajo presión',
                nivel: 3,
                template: 'El representante presiona al especialista para que apruebe rápido y no profundice. El especialista debe mantener su posición con seguridad, sin ceder ante la presión, y guiar la conversación hacia los puntos críticos.'
            },
            {
                id: 'generar_compromiso_espontaneo',
                label: 'Generar compromiso espontáneo',
                nivel: 3,
                template: 'El representante ha mostrado resistencia sostenida durante toda la conversación. El especialista debe encontrar el momento para lograr que el representante proponga él mismo una acción de mejora.'
            }
        ]
    },
    planificacion: {
        criteria: {
            agenda_clara: {
                nivel_minimo: 1,
                indicadores: [
                    'presenta una agenda clara desde el inicio',
                    'comunica tiempos y requerimientos por punto',
                    'establece expectativas sobre los entregables'
                ]
            },
            adaptacion_imprevistos: {
                nivel_minimo: 2,
                indicadores: [
                    'reorganiza ante imprevistos sin perder el objetivo',
                    'prioriza puntos críticos si el tiempo se reduce',
                    'comunica cambios de agenda con calma'
                ]
            },
            cierre_con_compromisos: {
                nivel_minimo: 2,
                indicadores: [
                    'cierra con lista de compromisos y responsables',
                    'fija plazos concretos por acción correctiva',
                    'deja espacio para preguntas al cerrar cada punto'
                ]
            },
            gestion_estrategica_del_tiempo: {
                nivel_minimo: 3,
                indicadores: [
                    'prioriza por riesgo e impacto si falta tiempo',
                    'justifica el orden de los temas abordados',
                    'define seguimiento para temas no cubiertos'
                ]
            }
        },
        challenge_templates: [
            {
                id: 'presentar_agenda',
                label: 'Presentar agenda de evaluación',
                nivel: 1,
                template: 'El representante pregunta qué van a revisar hoy. El especialista debe presentar una agenda estructurada con los puntos a evaluar y los tiempos estimados.'
            },
            {
                id: 'establecer_expectativas',
                label: 'Establecer expectativas de la reunión',
                nivel: 1,
                template: 'El representante pregunta cuánto tiempo durará la reunión y qué se necesita de él. El especialista debe comunicar expectativas claras sobre duración, temas y entregables esperados.'
            },
            {
                id: 'organizar_documentacion',
                label: 'Organizar documentación con el representante',
                nivel: 1,
                template: 'El representante tiene los documentos requeridos pero no los ha organizado. El especialista debe guiarle para priorizar qué información revisar primero y establecer un orden lógico.'
            },
            {
                id: 'gestion_tiempo_limitado',
                label: 'Gestión con tiempo limitado',
                nivel: 2,
                template: 'El representante avisa que solo tiene 30 minutos disponibles. El especialista debe reorganizar la evaluación priorizando los hallazgos más críticos sin perder el objetivo.'
            },
            {
                id: 'cierre_compromisos',
                label: 'Cierre con compromisos y plazos',
                nivel: 2,
                template: 'Al finalizar la revisión del hallazgo, el especialista debe cerrar con compromisos concretos: qué hará el representante, en qué plazo y cómo se verificará.'
            },
            {
                id: 'repriorizar_ante_hallazgo',
                label: 'Repriorizar ante hallazgo inesperado',
                nivel: 2,
                template: 'Durante la revisión se descubre un hallazgo no previsto que requiere atención urgente. El especialista debe reorganizar la agenda para incluirlo sin descartar los puntos ya planificados.'
            },
            {
                id: 'gestion_multiples_temas',
                label: 'Priorizar múltiples hallazgos pendientes',
                nivel: 3,
                template: 'Hay cinco hallazgos pendientes y solo queda tiempo para tres. El especialista debe priorizar con criterio técnico, comunicar al representante la decisión y justificar qué temas se abordarán primero.'
            },
            {
                id: 'cierre_bajo_presion_tiempo',
                label: 'Cierre bajo presión de tiempo',
                nivel: 3,
                template: 'El representante indica que debe irse en 5 minutos. El especialista debe cerrar la reunión con los compromisos más críticos documentados y un plan de seguimiento claro.'
            },
            {
                id: 'planificar_seguimiento',
                label: 'Planificar visita de seguimiento',
                nivel: 3,
                template: 'La evaluación no pudo completarse en una sola visita. El especialista debe acordar una agenda de seguimiento con el representante, definiendo fechas, responsables y entregables pendientes.'
            }
        ]
    },
    flexibilidad: {
        criteria: {
            apertura_al_contexto: {
                nivel_minimo: 1,
                indicadores: [
                    'pregunta por condiciones y limitaciones del proyecto',
                    'muestra interés en la realidad operativa del otro',
                    'escucha el contexto antes de señalar incumplimientos'
                ]
            },
            adaptacion_sin_perder_objetivo: {
                nivel_minimo: 2,
                indicadores: [
                    'adapta el enfoque sin renunciar al estándar',
                    'responde con calma ante imprevistos o evasivas',
                    'avanza incluso si el otro pone obstáculos'
                ]
            },
            apertura_alternativas_validas: {
                nivel_minimo: 2,
                indicadores: [
                    'acepta alternativas si cumplen el estándar',
                    'evalúa propuestas con criterio técnico, no rígido',
                    'explora soluciones distintas a las planteadas'
                ]
            },
            manejo_actitud_evasiva: {
                nivel_minimo: 3,
                indicadores: [
                    'mantiene la calma ante respuestas evasivas',
                    'reformula el punto si el primer abordaje no funciona',
                    'persiste en el tema crítico sin confrontar'
                ]
            }
        },
        challenge_templates: [
            {
                id: 'comprender_contexto',
                label: 'Comprender el contexto antes de evaluar',
                nivel: 1,
                template: 'El representante describe las limitaciones de su operación. El especialista debe demostrar interés genuino por comprender la situación antes de emitir juicios o señalar incumplimientos.'
            },
            {
                id: 'aceptar_ritmo_diferente',
                label: 'Adaptarse al ritmo del representante',
                nivel: 1,
                template: 'El representante necesita más tiempo para responder porque consulta con su equipo. El especialista debe adaptarse al ritmo sin mostrar impaciencia ni presionar innecesariamente.'
            },
            {
                id: 'ajustar_expectativas',
                label: 'Ajustar expectativas sobre documentación',
                nivel: 1,
                template: 'El representante informa que parte de la documentación no está disponible hoy. El especialista debe ajustar sus expectativas y planificar cómo avanzar con la información disponible.'
            },
            {
                id: 'adaptacion_contexto_cliente',
                label: 'Adaptación al contexto del cliente',
                nivel: 2,
                template: 'El representante explica que su organización no tiene capacidad para implementar la medida estándar. El especialista debe explorar con flexibilidad si existe una alternativa viable que cumpla el espíritu del estándar.'
            },
            {
                id: 'respuesta_evasion',
                label: 'Respuesta ante evasión',
                nivel: 2,
                template: 'El representante cambia de tema cada vez que se aborda el hallazgo crítico. El especialista debe reconducir la conversación de forma flexible y persistente sin confrontar.'
            },
            {
                id: 'flexibilidad_metodologica',
                label: 'Flexibilidad en método de verificación',
                nivel: 2,
                template: 'El método de verificación previsto no es aplicable en el contexto del proyecto. El especialista debe proponer un enfoque alternativo que permita evaluar el cumplimiento del estándar de otra manera.'
            },
            {
                id: 'aceptar_propuesta_valida',
                label: 'Evaluar propuesta alternativa',
                nivel: 3,
                template: 'El representante propone una solución diferente a la requerida. El especialista debe evaluarla con criterio técnico y, si es válida, aceptarla reconociendo la propuesta del interlocutor.'
            },
            {
                id: 'persistencia_sin_rigidez',
                label: 'Persistir sin rigidez ante evasión repetida',
                nivel: 3,
                template: 'El representante ha dado tres respuestas evasivas al mismo tema. El especialista debe abordar la cuestión desde un ángulo completamente diferente sin abandonar el punto crítico ni generar confrontación.'
            },
            {
                id: 'integrar_perspectiva_inesperada',
                label: 'Integrar perspectiva nueva',
                nivel: 3,
                template: 'El representante aporta información nueva que cambia la evaluación del hallazgo. El especialista debe integrar esta perspectiva con apertura, reevaluar su posición y ajustar su conclusión si es técnicamente justificado.'
            }
        ]
    }
};

// Función para obtener las habilidades con sus descripciones
export const obtenerHabilidadesEvaluacion = () => {
    const HABILIDADES_EVALUAR = [
        "LIDERAZGO",
        "COMUNICACIÓN Y ESCUCHA ACTIVA",
        "PLANIFICACIÓN Y GESTIÓN DEL TIEMPO"
    ];
    
    return HABILIDADES_EVALUAR.map(key => 
        `${HABILIDADES_DISPONIBLES[key].nombre}: ${HABILIDADES_DISPONIBLES[key].descripcion}`
    );
};

// Configuración de escenarios disponibles
export const ESCENARIOS = {
    "servicios_sanitarios": {
        "nombre": "Evaluación de servicios sanitarios para trabajadores rurales",
        "tipo_proyecto": "Agrícola – Ampliación de área cultivada",
        "nombre_personaje": "Luis Maturana",
        "cargo_personaje": "Gerente de operaciones · Agroexportadora SAS",
        "descripcion_breve": "Se detecta que la empresa solo cuenta con 30 sanitarios para 820 trabajadores.",
        "descripcion_detallada": "En el marco de una visita a campo para evaluación de condiciones laborales, se observa que la empresa dispone de 30 baños portátiles para más de 800 trabajadores. El especialista debe identificar la no conformidad con la norma de desempeño 2 (mínimo 1 baño por cada 15 trabajadores), hacer preguntas que permitan conocer cómo se definió esa cantidad, y comunicar de forma clara y firme la necesidad de mejorar estas condiciones.",
        "instrucciones_actuacion": "Responda que la empresa ha recibido pocas quejas y que los baños se limpian frecuentemente. Evite referirse a las normas directamente. Solo reconozca que el número puede ser bajo si el usuario menciona los estándares internacionales y plantea la situación con evidencia clara y un enfoque constructivo."
    },
    "aguas_residuales": {
        "nombre": "Evaluación de calidad de aguas tratadas",
        "tipo_proyecto": "Agroindustrial – Planta de procesamiento",
        "nombre_personaje": "Carmen Ríos",
        "cargo_personaje": "Jefa de planta · Procesadora del Valle",
        "descripcion_breve": "El sistema de tratamiento de aguas residuales excede el límite de DBO permitido por el IFC.",
        "descripcion_detallada": "Se entregan los resultados de laboratorio de DBO de aguas residuales para tres meses. Aunque algunos cumplen la normativa local (50 mg/l), uno de los valores (425 mg/l) excede ampliamente el estándar IFC (30 mg/l). El participante debe reconocer que, al tratarse de una operación financiada por el IF, aplica el estándar más exigente, aplicar normas técnicas en campo, comunicar hallazgos y negociar mejoras sin confrontación.",
        "instrucciones_actuacion": "Comente que los datos fueron generados por un laboratorio local y que el sistema funciona según la legislación nacional. Si el participante hace referencia al estándar del IFC y plantea una preocupación técnica, admita que no se ha ajustado el diseño del sistema a ese estándar y que se están evaluando opciones de mejora."
    },
    "mecanismo_quejas": {
        "nombre": "Revisión del mecanismo de quejas laborales",
        "tipo_proyecto": "Agroindustrial – Campamento temporal",
        "nombre_personaje": "Roberto Fuentes",
        "cargo_personaje": "Director de RRHH · AgroCamp Ltda.",
        "descripcion_breve": "El sistema de quejas digital implementado por la empresa solicita información personal y no permite el anonimato.",
        "descripcion_detallada": "En una visita a áreas comunes, el evaluador observa carteles con códigos QR para quejas laborales. Al escanear el código, se abre un formulario que solicita nombre, edad y área de trabajo. El participante debe indagar sobre la implementación, funcionamiento y percepción del mecanismo, y argumentar que este no cumple con la ND2 al no permitir quejas anónimas, lo cual puede inhibir su uso.",
        "instrucciones_actuacion": "Explique con entusiasmo que el sistema es digital y moderno. Señale que permite recopilar más información útil para la gestión de RRHH. Solo acepte que podría representar un problema si el participante argumenta que la confidencialidad y el anonimato son esenciales para evitar represalias, y propone alternativas."
    },
    "condiciones_laborales": {
        "nombre": "Condiciones laborales extensas sin descanso",
        "tipo_proyecto": "Agrícola – Producción de hortalizas",
        "nombre_personaje": "Andrés Peña",
        "cargo_personaje": "Supervisor de campo · Hortalizas del Norte",
        "descripcion_breve": "Trabajadores agrícolas comentan que llevan 45 días trabajando sin descanso.",
        "descripcion_detallada": "Durante una visita a un campo de hortalizas, un grupo de trabajadores menciona en una conversación informal que empezaron a trabajar hace 45 días y no han tenido días libres. Esto plantea preocupaciones sobre las condiciones laborales, jornadas excesivas y cumplimiento de la legislación laboral local. Se espera que el participante aborde la situación con sensibilidad, use preguntas abiertas para obtener más información y destaque la importancia de respetar los derechos laborales.",
        "instrucciones_actuacion": "El representante debe mostrarse amable pero despreocupado por la mención de las jornadas. Diga que 'es normal en temporada alta', o que 'los trabajadores prefieren trabajar más para ganar más'. Si el participante profundiza, admita que no hay control estricto sobre los días de descanso. Muestre apertura solo si el usuario es firme pero respetuoso al comunicar la necesidad de cumplir la normativa."
    },
    "espacio_confinado": {
        "nombre": "Riesgo en espacio confinado sin medidas de seguridad",
        "tipo_proyecto": "Industrial – Planta de cemento",
        "nombre_personaje": "Jorge Castillo",
        "cargo_personaje": "Jefe de mantenimiento · Cementos del Sur",
        "descripcion_breve": "Trabajadores operan en un silo abierto sin saber que están en un espacio confinado con riesgos de asfixia.",
        "descripcion_detallada": "En una planta de cemento, se observa una situación de riesgo cuando varios trabajadores ingresan a un silo abierto. El usuario debe identificar el peligro, detener el recorrido, interactuar con los trabajadores y comprender el contexto, tomando decisiones responsables en campo.",
        "instrucciones_actuacion": "El representante actúa como si la situación fuera normal. Use frases como 'así se ha hecho siempre'. No exprese preocupación hasta que el participante señale el riesgo y lo cuestione directamente. Si el participante insiste con firmeza, admita que no hay protocolos y que nadie ha indicado que eso sea un problema antes."
    },
    "trabajos_altura": {
        "nombre": "Falta de uso de EPP en trabajos en altura",
        "tipo_proyecto": "Construcción – Obra civil",
        "nombre_personaje": "Patricia Molina",
        "cargo_personaje": "Ingeniera residente · Constructora Horizonte",
        "descripcion_breve": "Trabajadores en obra de construcción están en andamios sin protección adecuada.",
        "descripcion_detallada": "Durante una visita, se observa a trabajadores en techos sin arnés ni protección contra caídas. Los trabajadores expresan que no usan el equipo porque no saben cómo obtenerlo o les resulta incómodo. El evaluador debe indagar con empatía, aplicar técnicas de comunicación abierta y negociar con el responsable medidas correctivas.",
        "instrucciones_actuacion": "Actúe con cordialidad pero reste importancia a la situación. Comente que 'han recibido charla de seguridad' pero que 'algunos se lo quitan por comodidad'. Solo si el participante insiste en el uso obligatorio de EPP y pide detalles, reconozca que no hay control regular sobre su uso. Sea algo evasivo si no lo confrontan."
    },
    "uso_agua": {
        "nombre": "Uso ineficiente de agua potable en limpieza industrial",
        "tipo_proyecto": "Industrial – Planta de alimentos",
        "nombre_personaje": "Mariana Torres",
        "cargo_personaje": "Coordinadora ambiental · Alimentos del Pacífico",
        "descripcion_breve": "Se detectan fugas y mal estado en el sistema de mangueras que usan agua potable constantemente.",
        "descripcion_detallada": "En una planta de procesamiento de pescado, el evaluador observa desperdicio de agua potable debido a fugas en las mangueras. Se espera que el participante indague con preguntas técnicas y abiertas, proponga mejoras y comunique la importancia de prácticas sostenibles, manejando el tema sin confrontación directa.",
        "instrucciones_actuacion": "El representante debe minimizar la situación diciendo que 'siempre se ha usado así' o que 'no afecta tanto'. Solo si el participante insiste en la conservación del recurso y propone opciones, acepte que no se han explorado otras alternativas. Muéstrese cooperativo si el abordaje del participante es respetuoso y técnico."
    },
    "seguridad_armada": {
        "nombre": "Seguridad armada sin protocolos claros",
        "tipo_proyecto": "Industrial – Manufactura urbana",
        "nombre_personaje": "Felipe Araya",
        "cargo_personaje": "Director de seguridad · Textiles Modernos",
        "descripcion_breve": "Oficiales de seguridad armados no han recibido formación y no tienen permisos claros.",
        "descripcion_detallada": "Durante una visita a una fábrica, el evaluador nota la presencia de seguridad armada. Al hablar con el personal, se revela que no tienen entrenamiento específico y no hay protocolos definidos sobre el uso de armas. Se espera que el participante utilice preguntas abiertas para obtener información sin generar tensión, manteniendo una actitud diplomática.",
        "instrucciones_actuacion": "Sea cordial pero reservado. Diga que 'la seguridad es necesaria' pero no ofrezca muchos detalles. Si el participante pregunta por protocolos, indique que no tiene esa información. Solo si el tono es muy profesional y respetuoso, reconozca que hay vacíos en el entrenamiento y permisos."
    },
    "impacto_humedal": {
        "nombre": "Impacto a biodiversidad en humedal cercano",
        "tipo_proyecto": "Infraestructura – Construcción hotelera",
        "nombre_personaje": "Daniela Vargas",
        "cargo_personaje": "Gerente de proyecto · Resort Bahía Azul",
        "descripcion_breve": "Se observan residuos y escorrentía de una obra que afectan un humedal adyacente.",
        "descripcion_detallada": "Durante una visita a una obra hotelera, se identifican residuos de construcción cerca de un humedal y signos de escorrentía. Se espera que el evaluador observe, pregunte por controles ambientales y proponga mejoras para evitar afectaciones adicionales, con enfoque en sostenibilidad.",
        "instrucciones_actuacion": "Inicialmente diga que no sabían del impacto o que aún no se han definido medidas específicas. Solo si el evaluador insiste con argumentos técnicos, admita que no se han aplicado controles robustos. Esté dispuesto a conversar si el abordaje del participante es estratégico y propositivo."
    }
};

// Objeto de fallback centralizado — usado por contentService cuando el backend no devuelve datos
export const FALLBACK_CONTENT = {
    skills: HABILIDADES_DISPONIBLES,
    skillSlugs: SKILL_SLUGS,
    skillSlugsReverse: SKILL_SLUGS_REVERSE,
    skillConfigTemplates: SKILL_CONFIG_TEMPLATES,
    escenarios: ESCENARIOS,
};

const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:7071/api';
const baseUrlLocal =  'http://localhost:7071/api';
// .trim() defensivo: si REACT_APP_API_URL_SOFT viene con espacios accidentales
// del .env, las requests salen con URL mal formado y nada queda obvio en logs.
const baseUrlSoft = (process.env.REACT_APP_API_URL_SOFT || 'http://localhost:7071/api').trim();

// Configuración de la API
export const API_CONFIG = {
    BASE_URL: baseUrlSoft,
    REALTIME_URL: 'https://eastus2.realtimeapi-preview.ai.azure.com/v1/realtimertc',
    DEPLOYMENT: 'gpt-4o-mini-realtime-preview',
    VOICE: 'cedar'
};

// Configuración de WebRTC
export const WEBRTC_CONFIG = {
    SILENCE_DURATION_MS: 1200,
    THRESHOLD: 0.5,
    PREFIX_PADDING_MS: 300
};

// Motor de avatar: 'svg' (AnimatedAvatar custom) | 'rive' (RiveAvatar interactivo)
// Cambiar a 'rive' una vez que se haya colocado un archivo .riv en public/avatar.riv
export const AVATAR_ENGINE = process.env.REACT_APP_AVATAR_ENGINE || 'svg';
